import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  notificationFeedAdapter,
  NotificationFeedStateModel,
  NotificationFeedStateKey,
} from './notification-feed-state.model';

const { selectAll } = notificationFeedAdapter.getSelectors();

export namespace NotificationFeedSelectors {
  export const selectNotificationFeedState =
    createFeatureSelector<NotificationFeedStateModel>(NotificationFeedStateKey);

  export const selectNotifications = createSelector(selectNotificationFeedState, selectAll);

  export const selectHasMore = createSelector(selectNotificationFeedState, state => state.hasMore);

  export const selectFilterBy = createSelector(selectNotificationFeedState, state => state.filterBy);

  export const selectPageAndFilter = createSelector(selectNotificationFeedState, state => ({
    currentPage: state.currentPage,
    filterBy: state.filterBy,
  }));

  export const selectFeedVm = createSelector(
    selectNotifications,
    selectHasMore,
    selectFilterBy,
    (notifications, hasMore, filterBy) => ({
      notifications,
      hasMore,
      filterBy,
    })
  );
}
